import { SummarizerConfig } from '../../types/summarizer';

export const facebookSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'facebook-summarizer',
  title: 'Facebook Summarizer',
  description: 'Summarize Facebook posts, videos, pages, and group discussions',
  version: '1.0.0',
  
  // Categorization
  category: 'social',
  tags: ['facebook', 'social-media', 'posts', 'videos', 'pages'],
  
  // Input configuration
  inputs: {
    file: {
      enabled: false // Facebook content is accessed via URL
    },
    url: {
      enabled: true,
      placeholder: 'Enter Facebook post, video, or page URL',
      validation: /(facebook\.com|fb\.com)/,
      examples: [
        'https://www.facebook.com/username/posts/123456789...',
        'https://www.facebook.com/watch/?v=123456789...',
        'https://www.facebook.com/username/',
        'https://www.facebook.com/groups/groupname/posts/123...'
      ],
      helpText: 'Paste any public Facebook post, video, page, or group discussion URL to get an instant summary.',
      showExamples: true,
      showHelpText: true,
    },
    text: {
      enabled: true,
      placeholder: 'Or paste the Facebook post content here',
      maxLength: 50000,
      minLength: 50,
      rows: 8
    }
  },
  
  // Output features
  outputs: {
    summary: true,
    chat: true,
    repurpose: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: false,
    download: true,
    share: true
  },
  
  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'facebook',
    timeout: 30000
  },
  
  // UI customization
  ui: {
    primaryColor: '#1877f2',
    secondaryColor: '#42b883',
    icon: '📘',
    theme: 'light'
  },
  
  // Validation rules
  validation: {
    required: true,
    minSize: 0,
    maxSize: 0,
    allowedDomains: [
      'facebook.com',
      'fb.com',
      'm.facebook.com',
      'www.facebook.com'
    ],
    blockedDomains: []
  },
  
  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false
  },
  
  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01'
};